module.exports = __webpack_public_path__ + "img/3.7ee25e9a.jpg";